export const SUPPORT_MARQII_URL = 'https://help.marqii.com/'
